import { useState } from 'react';
import {
  IconButton,
  Tooltip,
  Typography,
  Box,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

interface CopyLinkButtonProps {
  link: string;           // the URL/text to copy
  label?: string;         // optional text to show before the button
}

export default function CopyLinkButton({ link }: CopyLinkButtonProps) {
  const [tooltipText, setTooltipText] = useState('Copy link');

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setTooltipText('Copied!');
      setTimeout(() => setTooltipText('Copy link'), 2000); // reset after 2s
    } catch (err) {
      console.error('Failed to copy:', err);
      setTooltipText('Copy failed');
      setTimeout(() => setTooltipText('Copy link'), 3000);
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
      <Typography
        variant="body1"
        sx={{
          fontFamily: 'monospace',
          bgcolor: 'action.hover',
          px: 1,
          py: 0.5,
          borderRadius: 1,
          maxWidth: '300px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {link}
      </Typography>

      <Tooltip title={tooltipText} arrow placement="top">
        <IconButton
          onClick={handleCopy}
          size="small"
          color="primary"
          aria-label="copy link to clipboard"
        >
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}